'use client';

import { useEffect } from 'react';
import { setCookie } from 'cookies-next';
import { PROMO_CODE_COOKIE_NAME } from '@/lib/constants/maverick';

interface PromoCodeCookieSetterProps {
  promoCode: string;
}

/**
 * Client component that sets the whoop-promo-code cookie when a user is in raf/aff/partnership flow (doesn't render anything )
 */
export function PromoCodeCookieSetter({
  promoCode,
}: PromoCodeCookieSetterProps) {
  useEffect(() => {
    if (!promoCode) return;

    try {
      const now = new Date();
      // Add 400 days (in milliseconds) to the current time
      const fourHundredDaysInMs = 400 * 24 * 60 * 60 * 1000;
      const expiryDate = new Date(now.getTime() + fourHundredDaysInMs);

      setCookie(PROMO_CODE_COOKIE_NAME, promoCode, {
        expires: expiryDate,
      });
    } catch {}
  }, [promoCode]);

  return null;
}
